export default __webpack_public_path__ + "static/media/clouds-moon.4249a3f3.svg";